import React from 'react';
import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { Dropdown, Tab, Form, Button, Badge, Modal } from 'react-bootstrap';
import {
  getAssignedHotels,
  updateHotelBooking,
  updateHotelAgent,
  addCommentHotel,
} from '../../services/bookingServices';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { sendHotelInvoice } from '../../services/invoiceServices';

//Images

import DeleteModalPackage from './DelteModalPackage';
import BookingsEdit from './BookingsEdit';
import {
  FaEdit,
  FaTrash,
  FaCheckCircle,
  FaTimesCircle,
  FaPlane,
  FaClock,
  FaPauseCircle,
  FaExclamationTriangle,
  FaUndo,
} from 'react-icons/fa';

const DropdownBlog = ({ tour, handleSendInvoice, handleDownloadInvoice, viewConversations, addMessage }) => {
  //Add package
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  //delete
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleDeleteShow = () => setShowDeleteModal(true);
  const handleDeleteClose = () => setShowDeleteModal(false);
  const handleDelete = () => {
    // Add delete logic here
    handleClose();
  };

  return (
    <>
      <Dropdown className="dropdown">
        <Dropdown.Toggle as="div" className="btn-link i-false" data-bs-toggle="dropdown" aria-expanded="false">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu">
          <Dropdown.Item className="dropdown-item">
            <div>
              <Button variant="transparent" style={{ padding: '0px' }} onClick={viewConversations}>
                View Comments
              </Button>
            </div>
          </Dropdown.Item>
          <Dropdown.Item className="dropdown-item">
            {' '}
            <div>
              <Button variant="transparent" onClick={addMessage} style={{ padding: '0px' }}>
                Add Comments
              </Button>

              <DeleteModalPackage show={showDeleteModal} handleClose={handleDeleteClose} handleDelete={handleDelete} />
            </div>
          </Dropdown.Item>
          <Dropdown.Item className="dropdown-item">
            <div>
              <Button variant="transparent" style={{ padding: '0px' }} onClick={() => handleDownloadInvoice(tour)}>
                Download Invoice
              </Button>
            </div>
          </Dropdown.Item>{' '}
          <Dropdown.Item className="dropdown-item">
            <div>
              <Button variant="transparent" style={{ padding: '0px' }} onClick={() => handleSendInvoice(tour)}>
                Send Invoice
              </Button>
            </div>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
const BookTable = () => {
  const [selectBtn, setSelectBtn] = useState('Newest');

  //Actions

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('newest');
  const [totalEntries, setTotalEntries] = useState(0);
  const [totalPages, setTotalPages] = useState(1); // Total pages from API
  const [tableData, setTableData] = useState([]);
  const [showAddMessageModal, setShowAddMessageModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const [status, setStatus] = useState('All status');

  const handleDownloadInvoice = async (booking) => {
    const invoiceElement = document.getElementById(`invoice-${booking._id}`);
    if (!invoiceElement) {
      console.error('Invoice element not found!');
      return;
    }

    // Ensure the invoice is visible before rendering
    invoiceElement.style.display = 'block';

    // Wait for images to fully load before capturing
    const loadImages = async () => {
      const images = invoiceElement.querySelectorAll('img');
      const promises = Array.from(images).map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) resolve();
            else img.onload = resolve;
          })
      );

      await Promise.all(promises);
    };

    await loadImages();

    // Convert to canvas
    setTimeout(async () => {
      try {
        const canvas = await html2canvas(invoiceElement, {
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#fff',
          scale: 2, // High resolution
        });

        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'px',
          format: [794, 1123], // A4 size
        });

        pdf.addImage(imgData, 'PNG', 0, 0, 794, 1123);
        pdf.save(`Invoice-${booking._id}.pdf`);
      } catch (error) {
        console.error('Error generating PDF:', error);
      } finally {
        // Hide the invoice again after capturing
        invoiceElement.style.display = 'none';
      }
    }, 1000); // Delay to ensure proper rendering
  };
  const fetchBookings = async () => {
    try {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem('user'));
      const data = await getAssignedHotels(user.id, {
        page: currentPage,
        limit: itemsPerPage,
        sort: sortOrder,
      });
      if (data && Array.isArray(data.data)) {
        setBookings(data.data);
        setTotalPages(data?.totalPages); // ✅ Update total pages
        setTotalEntries(data.totalRecords); // ✅ Ensure this is updated
      } else {
        setBookings([]);
      }
    } catch (error) {
      console.error('Error fetching hotel bookings:', error);
    } finally {
      setLoading(false);
    }
  };
  // Fetch bookings
  useEffect(() => {
    fetchBookings();
  }, [search, currentPage, itemsPerPage, sortOrder]);
  useEffect(() => {
    let tempData = [...bookings];

    // 🔍 **Search Filter**
    if (search.trim()) {
      tempData = tempData.filter(
        (row) =>
          row?.customer?.name?.toLowerCase().includes(search.toLowerCase().trim()) ||
          row?.hotel?.name?.toLowerCase().includes(search.toLowerCase().trim())
      );
    }
    // 🚦 **Status Filter (Only Apply If Not "All Status")**
    if (status && status !== 'All status') {
      tempData = tempData.filter((row) => row?.status === status);
    }

    setTableData(tempData);
  }, [search, bookings,status]);

  const handleAgentChange = async (bookingId, newStatus) => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));

      const updatedData = {
        status: newStatus,
        agent: newStatus === 'Managed' ? user.id : null, // Assign or unassign agent
      };
      await updateHotelAgent(bookingId, updatedData);
      // setManageStatus(status); // Update UI state
      setTableData((prevData) =>
        prevData.map((booking) => (booking._id === bookingId ? { ...booking, agent: updatedData.agent } : booking))
      );
    } catch (error) {
      console.error('Error updating booking status:', error);
    }
  };

  // Function to handle status change
  const handleStatusChange = async (bookingId, newStatus) => {
    try {
      // Call API to update status
      const updatedData = { status: newStatus };
      await updateHotelBooking(bookingId, updatedData);

      // Update state to reflect the new status
      setTableData((prevHotels) =>
        prevHotels.map((Hotel) => (Hotel._id === bookingId ? { ...Hotel, status: newStatus } : Hotel))
      );

      

      alert('Hotel booking status updated successfully!');
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update Hotel booking status.');
    }
  };
  const handleAddMessage = (booking) => {
    setSelectedBooking(booking);
    setShowAddMessageModal(true);
  };
  const handleViewConversations = (booking) => {
    setSelectedBooking(booking);
    setShowConversationModal(true);
  };

  const handleSendMessage = async () => {
    if (!comment.trim()) return; // Prevent empty messages

    setLoading(true);
    setError(null);

    try {
      let newConversation = {
        bookingId: selectedBooking?._id,
        senderType: 'Employee',
        text: comment,
      };

      const res = await addCommentHotel(newConversation);
            alert('Comment added successfully!')


      setComment(''); // Clear input field
      fetchBookings();
    } catch (err) {
      setError('Failed to send message.');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeColor = (status) => {
    let color;
    switch (status) {
      case 'Open':
        color = '#28a745';
        break; // Green for completed
      case 'Completed':
        color = '#28a745';
        break; // Green for completed
      case 'Processing':
        color = '#ffc107';
        break; // Yellow for processing
      case 'On Hold':
        color = '#dc3545';
        break; // Red for on hold
      case 'Pending':
        color = '#28a745';
        break; // Blue for pending
      case 'Cancelled':
        color = '#6c757d';
        break; // Grey for cancelled
      case 'Refund Initiated':
        color = '#007bff';
        break; // Blue for refund initiated
      case 'Refund Completed':
        color = '#28a745';
        break; // Green for refund completed
      default:
        color = '#343a40';
    }
    return {
      border: `1px solid ${color}`,
      borderRadius: '10px',
      color: color,
      backgroundColor: 'transparent',
      padding: '10px 10px',
      fontWeight: '600',
      fontSize: '14px',
      minWidth: '100px',
      textAlign: 'center',
    }; // Default dark color
  };

  const [data, setData] = useState(document.querySelectorAll('#example2_wrapper tbody tr'));
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // use effect
  useEffect(() => {
    setData(document.querySelectorAll('#example2_wrapper tbody tr'));
    //chackboxFun();
  }, [test]);

  const handleSendInvoice = async (booking) => {
    const res = await sendHotelInvoice(booking?.customer?.email, booking);
    alert(`Hotel booking invoice sent to ${booking?.customer?.email}`);
  };

  const renderStatusBadge = (status) => {
    const badgeStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      // width:"150px",
      // minWidth: "50px", // Ensures all badges are of the same size
      // padding: "0.5rem 0.5rem", // Adjust padding for better alignment,
      fontSize: '12px',
    };
    switch (status) {
      case 'Pending':
        return (
          <Badge bg="secondary" style={badgeStyle}>
            Pending <FaClock />
          </Badge>
        );
      case 'Processing':
        return (
          <Badge bg="info" style={badgeStyle}>
            Processing <FaPauseCircle />
          </Badge>
        );
      case 'Open':
        return (
          <Badge bg="success" style={badgeStyle}>
            Open <FaCheckCircle />
          </Badge>
        );
      case 'Completed':
        return (
          <Badge bg="success" style={badgeStyle}>
            Completed <FaCheckCircle />
          </Badge>
        );
      case 'Confirmed':
        return (
          <Badge bg="success" style={badgeStyle}>
            Confirmed <FaCheckCircle />
          </Badge>
        );
      case 'On Hold':
        return (
          <Badge bg="warning" style={badgeStyle}>
            On Hold <FaExclamationTriangle />
          </Badge>
        );
      case 'Cancelled':
        return (
          <Badge bg="danger" style={badgeStyle}>
            Cancelled <FaTimesCircle />
          </Badge>
        );
      case 'Refund Initiated':
        return (
          <Badge bg="primary" style={badgeStyle}>
            Refund Initiated <FaUndo />
          </Badge>
        );
      case 'Refund Completed':
        return (
          <Badge bg="success" style={badgeStyle}>
            Refund Completed <FaCheckCircle />
          </Badge>
        );
      // default:
      //   return (
      //     <Badge bg="dark" style={badgeStyle}>
      //       Unknown <FaExclamationTriangle />
      //     </Badge>
      //   );
    }
  };
  return (
    <Tab.Container defaultActiveKey="All">
      <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
        <h4
          style={{
            // marginRight: "60%",
            // display: "inline-block",
            borderBottom: '2px solid darkGreen',
            color: 'darkGreen',
          }}
        >
          Hotel Bookings
        </h4>
        <div className="d-flex justify-content-end align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-1 d-flex align-items-center">
            <style>
              {`
                  .custom-placeholder::placeholder {
                    color: rgba(255, 99, 132);
                    opacity: 1;
                    
                  }
                `}
            </style>
            <Form.Control
              type="text"
              placeholder="Search by customer or hotel name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="custom-placeholder shadow-md"
              style={{
                border: '1px solid rgba(255, 99, 132)',
                height: '50px',
                width: '250px',
                fontWeight: '400',
                fontSize: '14px',
                // marginRight: "10px",
                backgroundColor: 'transparent',
              }}
            />
          </div>
          <div className="d-flex align-items-center mb-1">
            <div className="newest ms-3">
              <Dropdown>
                <Dropdown.Toggle
                  as="div"
                  className=" btn-select-drop default-select btn i-false"
                  style={{
                    color: '#28a745', // Custom green text
                    borderColor: '#28a745', // Custom green border
                  }}
                >
                  {selectBtn} <i className="fas fa-angle-down ms-2 "></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      setSortOrder('newest');
                      setSelectBtn('Newest');
                    }}
                    eventKey="All"
                  >
                    Newest
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setSortOrder('oldest');
                      setSelectBtn('Oldest');
                    }}
                    eventKey="All"
                  >
                    Oldest
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="newest ms-3">
              <Dropdown>
                <Dropdown.Toggle
                  as="div"
                  className="btn-select-drop default-select btn i-false"
                  style={{
                    color: '#28a745', // Custom green text
                    borderColor: '#28a745', // Custom green border
                  }}
                >
                  {status} <i className="fas fa-angle-down ms-2"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {[
                    'All status',
                    'Completed',
                    'Processing',
                    'Confirmed',
                    'On Hold',
                    'Pending',
                    'Cancelled',
                    'Refund Initiated',
                    'Refund Completed',
                  ].map((statusOption) => (
                    <Dropdown.Item
                      key={statusOption}
                      onClick={() => {
                        setStatus(statusOption); // ✅ Set selected status
                      }}
                    >
                      {statusOption}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <Tab.Content>
                <Tab.Pane eventKey="All" active show>
                  <div className="table-responsive">
                    <div id="room_wrapper" className="dataTables_wrapper no-footer">
                      <table className="table card-table display mb-4 dataTablesCard booking-table room-list-tbl dataTable no-footer">
                        <thead>
                          <tr>
                            <th>Customer Name</th>
                            <th>Hotel</th>
                            <th>Booking Date</th>
                            <th>Check-in</th>
                            <th>Check-out</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(tableData) && tableData.length > 0 ? (
                            tableData.map((hotel) => (
                              <tr key={hotel._id} className="text-center align-middle">
                                <td>{hotel.customer?.name || 'N/A'}</td>
                                <td>{hotel.hotel?.name || 'N/A'}</td>
                                <td>{moment(hotel.bookingTime).format('MMM DD, YYYY')}</td>
                                <td>{moment(hotel.checkInDate).format('MMM DD, YYYY')}</td>
                                <td>{moment(hotel.checkOutDate).format('MMM DD, YYYY')}</td>
                                {hotel?.agent ? (
                                  <td>
                                    <Dropdown>
                                      <Dropdown.Toggle variant="" size="sm" style={getStatusBadgeColor(hotel.status)}>
                                        {hotel.status}
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        {[
                                          'Completed',
                                          'Processing',
                                          'Confirmed',

                                          'On Hold',
                                          'Pending',
                                          'Cancelled',
                                          'Refund Initiated',
                                          'Refund Completed',
                                        ].map((status) => (
                                          <Dropdown.Item
                                            key={status}
                                            style={{ textAlign: 'center', padding: '10px 0' }}
                                            onClick={() => handleStatusChange(hotel._id, status)}
                                          >
                                            {status}
                                          </Dropdown.Item>
                                        ))}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                ) : (
                                  <td className="text-start">{renderStatusBadge(hotel.status)}</td>
                                )}

                                <td>
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant=""
                                      size="sm"
                                      style={{
                                        border: '1px solid',
                                        borderColor: '#28a745',
                                        borderRadius: '10px',
                                        color: '#28a745',
                                        padding: '10px 20px',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        minWidth: '100px',
                                        textAlign: 'center',
                                        backgroundColor: 'transparent',
                                      }}
                                    >
                                      {hotel.agent ? 'Managed' : 'Unmanaged'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu style={{ minWidth: '100px' }}>
                                      <Dropdown.Item
                                        style={{ textAlign: 'center', padding: '10px 0' }}
                                        onClick={() => handleAgentChange(hotel._id, 'Managed')}
                                      >
                                        Managed
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        style={{ textAlign: 'center', padding: '10px 0' }}
                                        onClick={() => handleAgentChange(hotel._id, 'Unmanaged')}
                                      >
                                        Unmanaged
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>

                                <td>
                                  <DropdownBlog
                                    tour={hotel}
                                    handleDownloadInvoice={handleDownloadInvoice}
                                    handleSendInvoice={handleSendInvoice}
                                    viewConversations={() => handleViewConversations(hotel)}
                                    addMessage={() => handleAddMessage(hotel)}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center py-3">
                                No hotel bookings found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {bookings.length > 0 && (
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                          <div className="dataTables_info">
                            Showing {(currentPage - 1) * itemsPerPage + 1} to{' '}
                            {Math.min(currentPage * itemsPerPage, totalEntries)} of {totalEntries} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers mb-0">
                            <Link
                              className={`paginate_button previous ${currentPage === 1 ? 'disabled' : ''}`}
                              onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            >
                              <i className="fa fa-angle-double-left"></i> Previous
                            </Link>
                            <span>
                              {[...Array(totalPages)].map((_, i) => (
                                <Link
                                  key={i}
                                  className={`paginate_button ${currentPage === i + 1 ? 'current' : ''}`}
                                  onClick={() => setCurrentPage(i + 1)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className={`paginate_button next ${currentPage === totalPages ? 'disabled' : ''}`}
                              onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            >
                              Next <i className="fa fa-angle-double-right"></i>
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </div>
      </div>
      {showConversationModal && (
        <Modal show={showConversationModal} onHide={() => setShowConversationModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Comments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedBooking.conversations?.length ? (
              <ul className="space-y-4">
                {selectedBooking.conversations.map((message, index) => (
                  <li key={index}>
                    <strong>
                      {message?.sender?.name} ({message?.sender?.type}):
                    </strong>{' '}
                    {message?.text}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No conversations available.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowConversationModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {showAddMessageModal && (
        <Modal show={showAddMessageModal} onHide={() => setShowAddMessageModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="mb-3">
                <label>Message</label>
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  className="form-control"
                  rows="3"
                ></textarea>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddMessageModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSendMessage}>
              Send
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {tableData.map((booking) => (
        <div key={booking._id}>
          {/* Invoice content (initially hidden) */}
          <div
            id={`invoice-${booking._id}`}
            style={{
              display: 'none',
              width: '794px',
              height: '1123px',
              padding: '40px',
              fontFamily: 'Arial, sans-serif',
              fontSize: '14px',
              color: '#333',
              backgroundColor: '#fff',
              textAlign: 'left',
            }}
          >
            {/* 🏨 Hotel Booking Invoice Header */}
            <h1 style={{ fontSize: '24px', textAlign: 'center', marginBottom: '20px' }}>🏨 Hotel Booking Invoice</h1>

            <hr style={{ borderTop: '2px solid #000', marginBottom: '10px' }} />

            {/* 📌 Customer Information */}
            <p>
              <strong>Customer:</strong> {booking?.customer?.name}
            </p>
            <p>
              <strong>Email:</strong> {booking?.customer?.email}
            </p>

            {/* 🏢 Hotel Information */}
            <p>
              <strong>Hotel:</strong> {booking?.hotel?.name}
            </p>
            <p>
              <strong>Location:</strong> {booking?.hotel?.hotelLocation?.address}, {booking?.hotel?.hotelLocation?.city}
              , {booking?.hotel?.hotelLocation?.country}
            </p>

            {/* 🛏 Room Information */}
            <p>
              <strong>Room Type:</strong> {booking?.room?.roomType} ({booking?.room?.bedType})
            </p>
            <p>
              <strong>Amenities:</strong> {booking?.room?.roomAmenities?.join(', ')}
            </p>

            {/* 📅 Booking Details */}
            <p>
              <strong>Check-in Date:</strong> {new Date(booking?.checkInDate).toLocaleDateString()}
            </p>
            <p>
              <strong>Check-out Date:</strong> {new Date(booking?.checkOutDate).toLocaleDateString()}
            </p>
            <p>
              <strong>Guests:</strong> {booking.guests}
            </p>
            <p>
              <strong>Price Per Night:</strong> ${booking?.room?.pricePerNight}
            </p>
            <p>
              <strong>Total Price:</strong> ${booking?.totalPrice}
            </p>

            <p>
              <strong>Booking Date:</strong> {new Date(booking?.bookingTime).toLocaleDateString()}
            </p>
            <p>
              <strong>Status:</strong> {booking?.status}
            </p>

            <hr style={{ borderTop: '2px solid #000', marginTop: '10px' }} />

            <p style={{ textAlign: 'center', fontSize: '12px', marginTop: '20px' }}>
              Thank you for choosing Unique Travels! 🏨✨
            </p>
          </div>
        </div>
      ))}
    </Tab.Container>
  );
};

export default BookTable;
